<template>
  <div id="app">
    <router-view></router-view>
    <div id="toast"></div>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style >
  #app{
    width: 100%;
    height:100%;
  }
  @import "assets/style/common.css";
</style>



// WEBPACK FOOTER //
// App.vue?6b72dbb6